<template>
  <ModalDialog
    ref="dialog"
    title="Edit Credit Details"
    icon="fa-money-check"
    :submitting="submitting"
    submitTitle="Update"
    @closed="onClosed"
    @submitted="onSubmitted">

    <FormGroup v-bind:form="creditForm" :labelColumnSize="2">
      <FormRow label="Entity Type">
        <FormSelect v-model="credit.entityType" field="entityType" :options="entityTypeOptions" note="Must be set for credit accounts" />
      </FormRow>
      <FormRow label="Trading Name">
        <div class="row">
          <div class="col-lg-6">
            <FormInputText v-model="credit.tradingName" field="tradingName" note="Must be set for credit accounts" />
          </div>
          <div class="col-lg-2">
            <label class="col-form-label">ABN</label>
          </div>
          <div class="col-lg-4">
            <FormInputText v-model="credit.abn" field="abn" note="Must be set for credit accounts" />
          </div>
        </div>
      </FormRow>

      <FormRow label="Trust Name" v-show="showTrustFields()">
        <div class="row">
          <div class="col-lg-6">
            <FormInputText v-model="credit.trustName" field="trustName" />
          </div>
          <div class="col-lg-2">
            <label class="col-form-label">Trust Commencement</label>
          </div>
          <div class="col-lg-4">
            <FormDate v-model="credit.trustCommence" field="trustCommence" />
          </div>
        </div>
      </FormRow>

      <FormRow label="Corporate Trustee?" v-show="showTrustFields()"><FormCheckbox v-model="credit.isCorporateTrustee" field="isCorporateTrustee" /></FormRow>

      <FormRow label="Legal Name" v-show="showLegalName()">
        <div class="row">
          <div class="col-lg-6">
            <FormInputText v-model="credit.legalName" field="legalName" />
          </div>
          <div class="col-lg-2">
            <label class="col-form-label" v-show="showCompanyFields()">ACN</label>
          </div>
          <div class="col-lg-4">
            <FormInputText v-show="showCompanyFields()" v-model="credit.acn" field="acn" />
          </div>
        </div>
      </FormRow>
      <FormRow label="Incorp. State" v-show="showCompanyFields()">
        <div class="row">
          <div class="col-lg-6">
            <FormInputText v-model="credit.incorpState" field="incorpState" />
          </div>
          <div class="col-lg-2">
            <label class="col-form-label">Incorp. Date</label>
          </div>
          <div class="col-lg-4">
            <FormDate v-model="credit.incorpDate" field="incorpDate" />
          </div>
        </div>
      </FormRow>
      <FormHorizontalRule />
      <FormRow label="Personal Guarantee">
        <div class="row">
          <div class="col-lg-6">
            <FormInputTextArea v-model="credit.personalGuarantee" field="personalGuarantee" />
          </div>
          <div class="col-lg-2">
            <label class="col-form-label">Signed Date</label>
          </div>
          <div class="col-lg-4">
            <FormDate v-model="credit.personalGuaranteeDateSigned" field="personalGuaranteeDateSigned" />
          </div>
        </div>
      </FormRow>
      <FormRow label="Veda Search"><FormDate v-model="credit.vedaSearch" field="vedaSearch" /></FormRow>
      <FormRow label="Account Opened">
        <div class="row">
          <div class="col-lg-6">
            <FormDate v-model="credit.accountOpened" field="accountOpened" />
          </div>
          <div class="col-lg-2">
            <label class="col-form-label">Application Date</label>
          </div>
          <div class="col-lg-4">
            <FormDate v-model="credit.creditApplicationDate" field="creditApplicationDate" />
          </div>
        </div>
      </FormRow>
      <FormRow label="Is Insured?">
        <div class="row">
          <div class="col-lg-5">
            <FormCheckbox v-model="credit.isInsured" field="isInsured" />
          </div>
          <div class="col-lg-3">
            <label class="col-form-label">Personal Property Secured?</label>
          </div>
          <div class="col-lg-4">
            <FormCheckbox v-model="credit.isPersonalPropertySecured" field="isPersonalPropertySecured" />
          </div>
        </div>
      </FormRow>
      <FormRow label="Insured Amount" v-show="isInsured()"><FormInputCurrency v-model="credit.insuredAmount" field="insuredAmount" /></FormRow>
      <div class="row" v-show="isPropertySecured()">
        <span class="col-lg-12 font-weight-bold">Personal Property Secured</span>
      </div>
      <FormRow label="PPS GONI" v-show="isPropertySecured()">
        <div class="row">
          <div class="col-lg-5">
            <FormInputText v-model="credit.personalPropGONI" field="personalPropGONI" />
          </div>
          <div class="col-lg-3">
            <label class="col-form-label">PPS Token</label>
          </div>
          <div class="col-lg-4">
            <FormInputText v-model="credit.personalPropToken" field="personalPropToken" />
          </div>
        </div>
      </FormRow>
      <FormRow label="PPS Registration" v-show="isPropertySecured()">
        <div class="row">
          <div class="col-lg-5">
            <FormInputText v-model="credit.personalPropRegistration" field="personalPropRegistration" />
          </div>
          <div class="col-lg-3">
            <label class="col-form-label">PPS Expiry Date</label>
          </div>
          <div class="col-lg-4">
            <FormDate v-model="credit.personalPropExpiry" field="personalPropExpiry" />
          </div>
        </div>
      </FormRow>

    </FormGroup>
  </ModalDialog>
</template>

<script>
import _ from 'lodash'
import form from '@/mixins/form'
import ModalDialog from '@/components/modalDialog.vue'
import modalDialog from '@/mixins/modalDialog'
import { ContactEntityTypes, ContactEntityLookup } from '@/store/types'

export default {
  name: "ContactEditCreditDialog",
  mixins: [
    modalDialog,
    form
  ],
  components: {
    ModalDialog
  },
  props: {
    contactId: Number,
    isCreateMode: Boolean
  },
  data() {
    return {
      credit: { },
      creditForm: {},
      submitting: false,
      entityTypeOptions: ContactEntityLookup,
    }
  },
  mounted() {

  },
  computed: {
  },
  methods: {
    show(credit) {
      // Reset form
      this.credit = { }
      this.creditForm = {}
      this.submitting = false

      if(credit != null) {
        this.credit = _.cloneDeep(credit)
      }
      
      if(this.credit.entityType == null)
        this.credit.entityType = ContactEntityTypes.none

      return modalDialog.methods.show.call(this, arguments)
    },
    onClosed() {
      this.modalClosed(false)
    },
    onSubmitted() {
      this.submitting = true

      var creditData = _.cloneDeep(this.$data.credit)
      
      // Pick values based on business logic (ie, don't send hidden fields)
      var updateData = _.pick(creditData, [
        'entityType', 'tradingName', 'abn', 'personalGuarantee', 'personalGuaranteeDateSigned', 'vedaSearch',
        'accountOpened', 'creditApplicationDate', 'isInsured', 'isPersonalPropertySecured'
      ])
      if(this.showTrustFields()) {
        _.merge(updateData, _.pick(creditData, ['trustName', 'trustCommence', 'isCorporateTrustee']))
      }
      if(this.showLegalName()) {
        _.merge(updateData, _.pick(creditData, ['legalName']))
      }
      if(this.showCompanyFields()) {
        _.merge(updateData, _.pick(creditData, ['acn', 'incorpState', 'incorpDate']))
      }
      if(this.isInsured()) {
        _.merge(updateData, _.pick(creditData, ['insuredAmount']))
        updateData.insuredAmount = this.sanitizeCurrency(updateData.insuredAmount)
      }
      if(this.isPropertySecured()) {
        _.merge(updateData, _.pick(creditData, ['personalPropGONI', 'personalPropToken', 'personalPropRegistration', 'personalPropExpiry']))
      }
      

      this.$apiService.contactService.updateContactCreditDetails(this.contactId, updateData)
        .then(() => {
          this.submitting = false
          this.modalClosed(true)
          this.hide()
        })
        .catch(err => {
          this.submitting = false
          this.$data.creditForm = this.processFormResponse(err)
        })
    },
    showLegalName() {
      if(this.credit.entityType == ContactEntityTypes.none || (this.credit.entityType == ContactEntityTypes.trust && !this.credit.isCorporateTrustee))
        return false
      return true
    },
    showCompanyFields() {
      if(this.credit.entityType == ContactEntityTypes.company || (this.credit.entityType == ContactEntityTypes.trust && this.credit.isCorporateTrustee))
        return true
      return false
    },
    showTrustFields() {
      return this.credit.entityType == ContactEntityTypes.trust
    },
    isInsured() {
      return this.credit.isInsured
    },
    isPropertySecured() {
      return this.credit.isPersonalPropertySecured
    }
  }
}
</script>